var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loadingFlag,
          expression: "loadingFlag",
          modifiers: { fullscreen: true, lock: true }
        }
      ],
      attrs: { id: "wrapper" }
    },
    [
      _c(
        "nav",
        {
          staticClass: "navbar-default navbar-static-side",
          attrs: { role: "navigation" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "sidebar-collapse" }, [
            _c(
              "ul",
              { staticClass: "nav", attrs: { id: "side-menu" } },
              [
                _c("li", { staticClass: "nav-header" }, [
                  _c("div", { staticClass: "dropdown profile-element" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "dropdown-toggle",
                        attrs: { "data-toggle": "dropdown", href: "#" }
                      },
                      [
                        _c("span", { staticClass: "clear" }, [
                          _c("span", { staticClass: "block m-t-xs" }, [
                            _c("strong", { staticClass: "font-bold" }, [
                              _vm._v("欢迎您, " + _vm._s(_vm.userName) + " !")
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { padding: "10px" } }, [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            "font-weight": "200"
                          }
                        },
                        [
                          _c("i", { staticStyle: { "margin-left": "5px" } }),
                          _vm._v(
                            "\n                         余额：" +
                              _vm._s(_vm.surplus) +
                              "元  \n                        "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { padding: "10px" } }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "el-button btn-outline el-button--default el-button--small is-plain",
                          on: { click: _vm.goReCharge }
                        },
                        [_vm._v("去充值")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "el-button btn-outline el-button--default el-button--small is-plain",
                          on: { click: _vm.reFreshReCharge }
                        },
                        [_vm._v("刷新")]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(2)
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "logo-element" }, [
                    _vm._v("H+\n                  ")
                  ])
                ]),
                _vm._v(" "),
                [
                  _vm.menus != undefined
                    ? _vm._l(_vm.menus, function(item, index) {
                        return _c(
                          "li",
                          { key: index },
                          [
                            item.menuLevel
                              ? [
                                  item.moduleID == 11063
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "J_menuItem",
                                          attrs: { src: "./main.html" }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-home"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "nav-label" },
                                            [_vm._v(_vm._s(item.moduleName))]
                                          )
                                        ]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "#",
                                            moduleID: item.moduleID,
                                            op: item.operation
                                              ? JSON.stringify(item.operation)
                                              : false
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa fa-bar-chart-o"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "nav-label" },
                                            [_vm._v(_vm._s(item.moduleName))]
                                          ),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "fa arrow"
                                          })
                                        ]
                                      ),
                                  _vm._v(" "),
                                  item.childs.length > 0
                                    ? _c(
                                        "ul",
                                        { staticClass: "nav nav-second-level" },
                                        _vm._l(item.childs, function(
                                          citem,
                                          cindex
                                        ) {
                                          return _c("li", { key: cindex }, [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "J_menuItem",
                                                attrs: {
                                                  src: citem.url,
                                                  op: citem.operation
                                                    ? JSON.stringify(
                                                        citem.operation
                                                      )
                                                    : false,
                                                  funcID: citem.funcID
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.addFUS(
                                                      citem.funcID,
                                                      citem.childs
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    citem.moduleName ||
                                                      citem.funcName ||
                                                      citem.analysisReportName
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            citem.childs &&
                                            citem.childs.length > 0
                                              ? _c(
                                                  "ul",
                                                  {
                                                    staticClass:
                                                      "nav nav-third-level"
                                                  },
                                                  _vm._l(citem.childs, function(
                                                    ccitem,
                                                    ccindex
                                                  ) {
                                                    return _c(
                                                      "li",
                                                      { key: ccindex },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "J_menuItem",
                                                            attrs: {
                                                              src: ccitem.url,
                                                              op: ccitem.operation
                                                                ? JSON.stringify(
                                                                    ccitem.operation
                                                                  )
                                                                : false
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                _vm.addFUS(
                                                                  ccitem.funcID
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                ccitem.reportName ||
                                                                  ccitem.funcName
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  })
                                                )
                                              : _vm._e()
                                          ])
                                        })
                                      )
                                    : _vm._e()
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      })
                    : [_vm._m(3)]
                ]
              ],
              2
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "gray-bg dashbard-1", attrs: { id: "page-wrapper" } },
        [
          _c("div", { staticClass: "row border-bottom" }),
          _vm._v(" "),
          _c("div", { staticClass: "row content-tabs" }, [
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "roll-nav roll-right J_tabExit",
                on: { click: _vm.exitSys }
              },
              [_c("i", { staticClass: "fa fa fa-sign-out" }), _vm._v(" 退出")]
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "row J_mainContent",
            attrs: { id: "content-main" }
          })
        ]
      ),
      _vm._v(" "),
      _vm._m(8)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-close" }, [
      _c("i", { staticClass: "fa fa-times-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "logoSty" }, [
      _c("img", {
        staticClass: "img-circle",
        attrs: { alt: "image", src: require("../../assets/img/logo.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "J_menuItem msg", attrs: { src: "./notice.html#/inbox" } },
      [
        _c("i", {
          staticClass: "fa fa-envelope-o",
          staticStyle: { "margin-right": "5px" }
        }),
        _vm._v("\n                      消息\n                      ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "#" } }, [
        _c("i", { staticClass: "fa fa-home" }),
        _vm._v(" "),
        _c("span", { staticClass: "nav-label" }, [
          _vm._v("对不起,菜单加载异常!")
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "fa arrow" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "roll-nav roll-left J_tabLeft" }, [
      _c("i", { staticClass: "fa fa-backward" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", { staticClass: "page-tabs J_menuTabs" }, [
      _c("div", { staticClass: "page-tabs-content" }, [
        _c(
          "a",
          {
            staticClass: "active J_menuTab",
            attrs: { href: "javascript:", "data-id": "./main.html" }
          },
          [_vm._v("首页")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "roll-nav roll-right J_tabRight" }, [
      _c("i", { staticClass: "fa fa-forward" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn-group roll-nav roll-right" }, [
      _c(
        "button",
        {
          staticClass: "dropdown J_tabClose",
          attrs: { "data-toggle": "dropdown" }
        },
        [_vm._v("关闭操作"), _c("span", { staticClass: "caret" })]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          staticClass: "dropdown-menu dropdown-menu-right",
          attrs: { role: "menu" }
        },
        [
          _c("li", { staticClass: "J_tabCloseAll" }, [
            _c("a", [_vm._v("关闭全部选项卡")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "J_tabCloseOther" }, [
            _c("a", [_vm._v("关闭其他选项卡")])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "right-sidebar" } }, [
      _c("div", { staticClass: "sidebar-container" }, [
        _c("ul", { staticClass: "nav nav-tabs navs-3" }, [
          _c("li", { staticClass: "active" }, [
            _c("a", { attrs: { "data-toggle": "tab", href: "#tab-1" } }, [
              _c("i", { staticClass: "fa fa-gear" }),
              _vm._v(" 主题\n                  ")
            ])
          ]),
          _vm._v(" "),
          _c("li", {}, [
            _c("a", { attrs: { "data-toggle": "tab", href: "#tab-2" } }, [
              _vm._v("\n                  通知\n              ")
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { "data-toggle": "tab", href: "#tab-3" } }, [
              _vm._v("\n                  项目进度\n              ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tab-content" }, [
          _c(
            "div",
            { staticClass: "tab-pane active", attrs: { id: "tab-1" } },
            [
              _c("div", { staticClass: "sidebar-title" }, [
                _c("h3", [
                  _c("i", { staticClass: "fa fa-comments-o" }),
                  _vm._v(" 主题设置")
                ]),
                _vm._v(" "),
                _c("small", [
                  _c("i", { staticClass: "fa fa-tim" }),
                  _vm._v(
                    " 你可以从这里选择和预览主题的布局和样式，这些设置会被保存在本地，下次打开的时候会直接应用这些设置。"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "skin-setttings" }, [
                _c("div", { staticClass: "title" }, [_vm._v("主题设置")]),
                _vm._v(" "),
                _c("div", { staticClass: "setings-item" }, [
                  _c("span", [_vm._v("收起左侧菜单")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "switch" }, [
                    _c("div", { staticClass: "onoffswitch" }, [
                      _c("input", {
                        staticClass: "onoffswitch-checkbox",
                        attrs: {
                          type: "checkbox",
                          name: "collapsemenu",
                          id: "collapsemenu"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "onoffswitch-label",
                          attrs: { for: "collapsemenu" }
                        },
                        [
                          _c("span", { staticClass: "onoffswitch-inner" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "onoffswitch-switch" })
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "setings-item" }, [
                  _c("span", [_vm._v("固定顶部")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "switch" }, [
                    _c("div", { staticClass: "onoffswitch" }, [
                      _c("input", {
                        staticClass: "onoffswitch-checkbox",
                        attrs: {
                          type: "checkbox",
                          name: "fixednavbar",
                          id: "fixednavbar"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "onoffswitch-label",
                          attrs: { for: "fixednavbar" }
                        },
                        [
                          _c("span", { staticClass: "onoffswitch-inner" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "onoffswitch-switch" })
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "setings-item" }, [
                  _c("span", [
                    _vm._v("\n                  固定宽度\n              ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "switch" }, [
                    _c("div", { staticClass: "onoffswitch" }, [
                      _c("input", {
                        staticClass: "onoffswitch-checkbox",
                        attrs: {
                          type: "checkbox",
                          name: "boxedlayout",
                          id: "boxedlayout"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "onoffswitch-label",
                          attrs: { for: "boxedlayout" }
                        },
                        [
                          _c("span", { staticClass: "onoffswitch-inner" }),
                          _vm._v(" "),
                          _c("span", { staticClass: "onoffswitch-switch" })
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "title" }, [_vm._v("皮肤选择")]),
                _vm._v(" "),
                _c("div", { staticClass: "setings-item default-skin nb" }, [
                  _c("span", { staticClass: "skin-name " }, [
                    _c("a", { staticClass: "s-skin-0", attrs: { href: "#" } }, [
                      _vm._v(
                        "\n                        默认皮肤\n                    "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "setings-item blue-skin nb" }, [
                  _c("span", { staticClass: "skin-name " }, [
                    _c("a", { staticClass: "s-skin-1", attrs: { href: "#" } }, [
                      _vm._v(
                        "\n                      蓝色主题\n                  "
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "setings-item yellow-skin nb" }, [
                  _c("span", { staticClass: "skin-name " }, [
                    _c("a", { staticClass: "s-skin-3", attrs: { href: "#" } }, [
                      _vm._v(
                        "\n                      黄色/紫色主题\n                  "
                      )
                    ])
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tab-pane", attrs: { id: "tab-2" } }, [
            _c("div", { staticClass: "sidebar-title" }, [
              _c("h3", [
                _c("i", { staticClass: "fa fa-comments-o" }),
                _vm._v(" 最新通知")
              ]),
              _vm._v(" "),
              _c("small", [
                _c("i", { staticClass: "fa fa-tim" }),
                _vm._v(" 您当前有10条未读信息")
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "sidebar-message" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "pull-left text-center" }, [
                    _c("img", {
                      staticClass: "img-circle message-avatar",
                      attrs: {
                        alt: "image",
                        src: require("../../assets/img/a1.jpg")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-t-xs" }, [
                      _c("i", { staticClass: "fa fa-star text-warning" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star text-warning" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _vm._v(
                      "\n\n                                  据天津日报报道：瑞海公司董事长于学伟，副董事长董社轩等10人在13日上午已被控制。\n                                  "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("今天 4:21")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-message" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "pull-left text-center" }, [
                    _c("img", {
                      staticClass: "img-circle message-avatar",
                      attrs: {
                        alt: "image",
                        src: require("../../assets/img/a2.jpg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _vm._v(
                      "\n                                  HCY48之音乐大魔王会员专属皮肤已上线，快来一键换装拥有他，宣告你对华晨宇的爱吧！\n                                  "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("昨天 2:45")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-message" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "pull-left text-center" }, [
                    _c("img", {
                      staticClass: "img-circle message-avatar",
                      attrs: {
                        alt: "image",
                        src: require("../../assets/img/a3.jpg")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-t-xs" }, [
                      _c("i", { staticClass: "fa fa-star text-warning" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star text-warning" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star text-warning" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _vm._v(
                      "\n                                  写的好！与您分享\n                                  "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("昨天 1:10")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-message" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "pull-left text-center" }, [
                    _c("img", {
                      staticClass: "img-circle message-avatar",
                      attrs: {
                        alt: "image",
                        src: require("../../assets/img/a4.jpg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _vm._v(
                      "\n                                  国外极限小子的炼成！这还是亲生的吗！！\n                                  "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("昨天 8:37")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-message" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "pull-left text-center" }, [
                    _c("img", {
                      staticClass: "img-circle message-avatar",
                      attrs: {
                        alt: "image",
                        src: require("../../assets/img/a8.jpg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _vm._v(
                      "\n\n                                  一只流浪狗被收留后，为了减轻主人的负担，坚持自己觅食，甚至......有些东西，可能她比我们更懂。\n                                  "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("今天 4:21")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-message" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "pull-left text-center" }, [
                    _c("img", {
                      staticClass: "img-circle message-avatar",
                      attrs: {
                        alt: "image",
                        src: require("../../assets/img/a7.jpg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _vm._v(
                      "\n                                  这哥们的新视频又来了，创意杠杠滴，帅炸了！\n                                  "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("昨天 2:45")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-message" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "pull-left text-center" }, [
                    _c("img", {
                      staticClass: "img-circle message-avatar",
                      attrs: {
                        alt: "image",
                        src: require("../../assets/img/a3.jpg")
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "m-t-xs" }, [
                      _c("i", { staticClass: "fa fa-star text-warning" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star text-warning" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fa fa-star text-warning" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _vm._v(
                      "\n                                  最近在补追此剧，特别喜欢这段表白。\n                                  "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("昨天 1:10")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-message" }, [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "pull-left text-center" }, [
                    _c("img", {
                      staticClass: "img-circle message-avatar",
                      attrs: {
                        alt: "image",
                        src: require("../../assets/img/a4.jpg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "media-body" }, [
                    _vm._v(
                      "\n                                  我发起了一个投票 【你认为下午大盘会翻红吗？】\n                                  "
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v("星期一 8:37")
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab-pane", attrs: { id: "tab-3" } }, [
            _c("div", { staticClass: "sidebar-title" }, [
              _c("h3", [
                _c("i", { staticClass: "fa fa-cube" }),
                _vm._v(" 最新任务")
              ]),
              _vm._v(" "),
              _c("small", [
                _c("i", { staticClass: "fa fa-tim" }),
                _vm._v(" 您当前有14个任务，10个已完成")
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "sidebar-list" }, [
              _c("li", [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "small pull-right m-t-xs" }, [
                    _vm._v("9小时以后")
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("市场调研")]),
                  _vm._v(" 按要求接收教材；\n\n                              "),
                  _c("div", { staticClass: "small" }, [_vm._v("已完成： 22%")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress progress-mini" }, [
                    _c("div", {
                      staticClass: "progress-bar progress-bar-warning",
                      staticStyle: { width: "22%" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-muted m-t-xs" }, [
                    _vm._v("项目截止： 4:00 - 2015.10.01")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "small pull-right m-t-xs" }, [
                    _vm._v("9小时以后")
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("可行性报告研究报上级批准 ")]),
                  _vm._v(
                    " 编写目的编写本项目进度报告的目的在于更好的控制软件开发的时间,对团队成员的 开发进度作出一个合理的比对\n\n                              "
                  ),
                  _c("div", { staticClass: "small" }, [_vm._v("已完成： 48%")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress progress-mini" }, [
                    _c("div", {
                      staticClass: "progress-bar",
                      staticStyle: { width: "48%" }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "small pull-right m-t-xs" }, [
                    _vm._v("9小时以后")
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("立项阶段")]),
                  _vm._v(
                    " 东风商用车公司 采购综合综合查询分析系统项目进度阶段性报告武汉斯迪克科技有限公司\n\n                              "
                  ),
                  _c("div", { staticClass: "small" }, [_vm._v("已完成： 14%")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress progress-mini" }, [
                    _c("div", {
                      staticClass: "progress-bar progress-bar-info",
                      staticStyle: { width: "14%" }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { attrs: { href: "#" } }, [
                  _c(
                    "span",
                    { staticClass: "label label-primary pull-right" },
                    [_vm._v("NEW")]
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("设计阶段")]),
                  _vm._v(" "),
                  _vm._v(
                    "\n                              项目进度报告(Project Progress Report)\n                              "
                  ),
                  _c("div", { staticClass: "small" }, [_vm._v("已完成： 22%")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-muted m-t-xs" }, [
                    _vm._v("项目截止： 4:00 - 2015.10.01")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "small pull-right m-t-xs" }, [
                    _vm._v("9小时以后")
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("拆迁阶段")]),
                  _vm._v(
                    " 科研项目研究进展报告 项目编号: 项目名称: 项目负责人:\n\n                              "
                  ),
                  _c("div", { staticClass: "small" }, [_vm._v("已完成： 22%")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress progress-mini" }, [
                    _c("div", {
                      staticClass: "progress-bar progress-bar-warning",
                      staticStyle: { width: "22%" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small text-muted m-t-xs" }, [
                    _vm._v("项目截止： 4:00 - 2015.10.01")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "small pull-right m-t-xs" }, [
                    _vm._v("9小时以后")
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("建设阶段 ")]),
                  _vm._v(
                    " 编写目的编写本项目进度报告的目的在于更好的控制软件开发的时间,对团队成员的 开发进度作出一个合理的比对\n\n                              "
                  ),
                  _c("div", { staticClass: "small" }, [_vm._v("已完成： 48%")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress progress-mini" }, [
                    _c("div", {
                      staticClass: "progress-bar",
                      staticStyle: { width: "48%" }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { attrs: { href: "#" } }, [
                  _c("div", { staticClass: "small pull-right m-t-xs" }, [
                    _vm._v("9小时以后")
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("获证开盘")]),
                  _vm._v(
                    " 编写目的编写本项目进度报告的目的在于更好的控制软件开发的时间,对团队成员的 开发进度作出一个合理的比对\n\n                              "
                  ),
                  _c("div", { staticClass: "small" }, [_vm._v("已完成： 14%")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "progress progress-mini" }, [
                    _c("div", {
                      staticClass: "progress-bar progress-bar-info",
                      staticStyle: { width: "14%" }
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1618dada", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1618dada","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/module/index/app.vue
// module id = null
// module chunks = 